import type { FC } from 'react';
import React from 'react';
import {
  Flex,
  Pill,
  Body,
  FlexRow,
  Col,
} from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import { Duration } from '@/components/Duration/Duration';

interface StopDurationMapItineraryProps {
  duration: number;
}

const StopDurationMapItinerary: FC<StopDurationMapItineraryProps> = ({
  duration,
}) => {
  const { t } = useTranslation();
  return (
    <Flex mb="1x_small">
      <Pill type="neutral" theme="soft" rounded>
        <FlexRow flexWrap="wrap" alignItems="center" gap="1">
          <Col>
            <Body type="xSmall" color="neutral.80" weight="medium">
              {t('flightSummary.itinerary.stop.duration')}:{' '}
            </Body>
          </Col>
          <Col>
            <Body type="xSmall" color="neutral.80" weight="medium">
              <Duration durationInMinutes={duration} />
            </Body>
          </Col>
        </FlexRow>
      </Pill>
    </Flex>
  );
};

export default StopDurationMapItinerary;
